import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { InsurancePickerView } from './InsurancePickerView';

export class InsurancePickerWithErrorOverride extends Component {
    static propTypes = {
        errorStateOverride: PropTypes.bool,
        isErrorState: PropTypes.bool,
    }

    static defaultProps = {
        errorStateOverride: false,
    }

    constructor(props) {
        super(props);

        this.state = {
            errorStateOverrideToggle: this.props.errorStateOverride,
        };
    }

    handleFocus = () => {
        if (this.state.errorStateOverrideToggle) {
            this.setState({ errorStateOverrideToggle: false });
        }
    }

    render() {
        const { isErrorState, ...props } = this.props;
        const { errorStateOverrideToggle } = this.state;

        const errorState = isErrorState || errorStateOverrideToggle;

        return (
            <InsurancePickerView
                {...props}
                isErrorState={errorState}
                onFocus={this.handleFocus}
            />
        );
    }
}
